import request from '../utils/request'

/**
 * 获取当前管理员所属企业信息
 */
export function getCurrentCompany() {
  return request({
    url: '/manager/user/company',
    method: 'get'
  })
}

/**
 * 获取用户列表（管理员端，只能查看自己企业的用户）
 */
export function getUserList(params) {
  return request({
    url: '/manager/user/list',
    method: 'get',
    params
  })
}

/**
 * 根据ID获取用户详情（管理员端）
 */
export function getUserById(id) {
  return request({
    url: `/manager/user/${id}`,
    method: 'get'
  })
}

/**
 * 创建用户（管理员端，只能创建自己企业的用户）
 */
export function createUser(data) {
  return request({
    url: '/manager/user',
    method: 'post',
    data
  })
}

/**
 * 更新用户（管理员端，只能更新自己企业的用户）
 */
export function updateUser(data) {
  return request({
    url: '/manager/user',
    method: 'put',
    data
  })
}

/**
 * 更新用户状态（管理员端）
 */
export function updateUserStatus(id, status) {
  return request({
    url: `/manager/user/${id}/status`,
    method: 'put',
    params: { status }
  })
}

/**
 * 重置用户密码（管理员端）
 */
export function resetPassword(id, newPassword) {
  return request({
    url: `/manager/user/${id}/password`,
    method: 'put',
    params: { newPassword }
  })
}

/**
 * 获取业务员列表（管理员端，仅启用）
 */
export function getSalesmanList() {
  return request({
    url: '/manager/report/salesmen',
    method: 'get'
  })
}

